module.exports = __webpack_public_path__ + "teqbahn-assets/media/noun_retention.196097c8.png";